
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Kindera.ts;
 * Path: ./src/environments/BaseEnvironments/Kindera.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 14/05/25, 10:10;
 * Updated at: 14/05/25, 10:10;
 *
 */

import { Accessori } from '../Modules/Accessori';
import { Clienti } from '../Modules/Clienti';
import { Fatture } from '../Modules/Fatture';
import { NotificheEnv } from '../Modules/Notifiche';
import { Prodotti } from '../Modules/Prodotti';
import { Progetti } from '../Modules/Progetti';
import { Scadenzario } from '../Modules/Scadenzario';
import { Fornitori} from '../Modules/Fornitori';
import { getModule, addModule } from '../Utility/ModuleUtility';
import { Module } from 'module';
import { CampoAggiuntivo } from 'src/app/shared/models/campo-aggiuntivo';
import { AccessoriCliente } from '../Modules/AccessoriCliente';
import { PresenzeClienti } from '../Modules/PresenzeClienti';
import { Menu } from 'angular-feather/icons';
import { CRM, CrmEnv } from '../Modules/CRM';
import { env } from './Edu';


export var Bimbo = () => {
  var env = addModule(Clienti(), {});
  env.Menu = []
  env = addModule({
    ClientiAddOn: {
      RuoloDefault: { id: "C", label: "Cliente" },
      repartoReferente: false,
      referentiFromPersone: true,
      hideApprovaPresenze: true,
      relazioniReferenti: true,
      longWeek: true,
      showClasse: true,
      multipleState: true,
      giorniFestivi: [7], //6 e 7 per sabato e domenica
      legendaPresenze: [
        { label: 'Presente', color: '#3ea26d' },
        { label: 'Assente', color:  '#ea582a'},
      ],
      tipiPresenze: [{id:'P', label:'Presente'}, {id:'A', label:'Assente'}]
    },
    Menu: [
      {
        path: "/kindera/bambini",
        title: "Bambini",
        icon: "fa fa-user",
        capacita: []
      }
    ]
  }, env);


  return env;
};


export var Attivita = () => {
  var env = addModule(Scadenzario(), {});
  env.Menu = [];
  env = addModule({
    Modules: {
      Scadenzario: false,
      dashboard:true,
    },
    CategorieAddon: {
      Sources: [
        { nome: 'Attività', tipo: 'S', restroute: '/scadenzario/scadenze/categorie', type: 'POST', param: {} }
      ],
    },
    ClientiAddOn: {

      Tabs: [
        {
          tipo: 'task',
          params: { tipo: 'S' },
          titolo: 'Attività',
          filtri: []
        },
      ],
    },
    TaskAddon: {
      hideDateFilter: true,
      DynamicFields: [
        {
          type: 'S',
          addButton: true,
          managerLoggato: {/*fieldexist:'manager'*/ },
          defaultFilter: { inizio: new Date().toISOString().split('T')[0], fine: new Date().toISOString().split('T')[0] },
          hideif: { hasNotCapacity: [] },
          restRoute: '/scadenzario/scadenze',
          initObj: [{ campo: 'partecipantiObject', tipo: 'array' }],
          Label: 'Attività',
          onSaveMap: (x) => {
            x.categorie = null;
            x.alert_inizio_task = 0;
            x.alert_fine_task = 0;
            return x
          },

          Azioni: [
            {
              nome: 'Elimina',
              close: true,
              class: ' btn ',
              labelClass: 'ml-1 text-danger font-weight-bold',
              type: 'POST',
              restRoute: '/scadenzario/scadenze/delete',
              preAlert: 'Sei sicuro di voler eliminare questo elemento?',
              icon: 'fas fa-trash text-danger',
              hideif: { fieldnotexist: 'id' },
              placeholder: 'Elimina',
              successMex: 'Elemento eliminato con successo',
              parameter: [{ nome: "id", parameter: 'id' }]
            }
          ],
          campi: [
            { nome: "Titolo", oggetti: ['nome'], modificabile: true, inputType: "text", class: 'col-lg-12', },
            {
              nome: 'Bambino',
              source: '/anagrafica/clienti/list',
              responseHasData: true,
              parameter: [{ nome: "page", value: 1 }, { nome: "size", value: 200 }, {
                nome: "ruolo",
                value: 'C'
              }, { nome: "inseriti", value: true }],
              oggetti: ['cliente'],
              internalOutput: 'clienteObject',
              OutputField: 'cliente',
              OnChange: 'OnClienteChange',
              modificabile: true,
              inputType: 'singleDropdown',
              placeholder: 'Seleziona un Bambino',
              settings: {
                singleSelection: true,
                closeDropDownOnSelection: true,
                singleOutput: true,
                idField: 'id',
                textField: 'fullName',
                searchPlaceholderText: "Cerca",
                allowSearchFilter: true,
                allowRemoteDataSearch: false,
              },
              class: 'col-lg-12',
              visibleifProhibited: true
            },
            {
              nome: "Note",
              oggetti: ['note'],
              modificabile: true,
              inputType: "textarea",
              class: 'col-lg-12',
            },
            {
              nome: "Data Inizio ",
              oggetti: ['data_inizio_prevista'],
              modificabile: true,
              inputType: "datetime-local",
              class: 'col-lg-6',
            },
            {
              nome: "Data Fine",
              oggetti: ['data_fine_prevista'],
              modificabile: true,
              inputType: "datetime-local",
              class: 'col-lg-6',
            },
          ],

          Headers: [
            { nome: "Data Inizio", oggetti: ['data_inizio_prevista'], inputType: 'datetime-local' },
            { nome: "Data Fine", oggetti: ['data_fine_prevista'], inputType: 'datetime-local' },
            { nome: "Autore", oggetti: ['autoreObject'], type: 'object', field: ['fullName'] },
            { nome: "Attività", oggetti: ['categorieObject'], type: 'objArray', field: ['categoria'] },
            { nome: "Note", oggetti: ['note'], inputType: 'textarea' },
            { nome: "Bambino", oggetti: ['clienteObject'], type: 'object', field: ['fullName'] },
            { nome: "Educatore", oggetti: ['partecipantiObject'], type: 'objArray', field: ['fullName'] },
            { nome: "Esito", oggetti: ['tipoObject'], type: 'object', field: ['label'] }
          ]

        },
      ]
    }
  }, env);
  return env;
};
function Notifiche() {
  return {
    type: '*',
    addButton: true,
    hideif: { hasNotCapacity: ['gestione-news'] },
    restRoute: '/task/notifiche',
    Label: 'Notifica',
    Azioni: [
    { nome: 'Invia Notifiche', class: ' btn ', labelClass: 'ml-1 text-orange font-weight-bold', type: 'POST', restRoute: '/task/notifiche/send', capacita: [], icon: 'fas fa-plane text-orange', placeholder: 'Invia Notifiche ai Clienti', successMex: "Notifiche inviate", hideif: { fieldnotexist: 'id' }, parameter: [{ nome: "ids", parameter: 'clienti' }, { nome: 'news', parameter: 'id' }] },
      { nome: 'Elimina', close: true, class: ' btn ', labelClass: 'ml-1 text-danger font-weight-bold', type: 'POST', restRoute: '/task/nenotifiche/delete', preAlert: 'Sei sicuro di voler eliminare questo elemento?', capacita: ['gestione-news'], icon: 'fas fa-trash text-danger', hideif: { fieldnotexist: 'id' }, placeholder: 'Elimina', successMex: 'Elemento eliminato con successo', parameter: [{ nome: "id", parameter: 'id' }] },
    ],
    campi: [
      { nome: 'Titolo:', oggetti: ['nome'], modificabile: true, inputType: 'text', class: 'col-lg-12' },
      { nome: 'Body:', oggetti: ['note'], inputType: 'html', modificabile: true, class: 'col-lg-12' },
      { nome: 'Data:', oggetti: ['data_inizio_prevista'], modificabile: true, inputType: 'date', class: 'col-lg-3' },
      { nome: 'Data Fine:', oggetti: ['data_fine_prevista'], modificabile: true, inputType: 'date', class: 'col-lg-3' },
      { nome: 'Pubblica:', oggetti: ['publicata'], modificabile: true, inputType: 'checkbox', class: 'col-lg-3' },
      {
        type: 'image',
        oggetti: ['id_immagine'],
        imageToServer: 'immagine',
        filename: 'file',
        titleClass: 'control-label col-form-label',
        class: 'col-md-12',
        visibleifProhibited: true,
        modificabile: true
      },
      CampoAggiuntivo.SingleDropdown("Bambini", "addclienti", '/anagrafica/clienti/list', 'nominativo', { OnChange: "AddCli", parameter: [{ nome: 'page', value: 0 }, { nome: 'size', value: 10 }], responseHasData: true }),
      { nome: 'Bambini Aggiunti', collapsable: true, collapsed: true, oggetti: ['clientiObject'], type: "table", header: [{ nome: "Bambino", oggetti: ['nominativo'] }], modificabile: true, class: 'col-lg-12', azioni: [{ ExternalOnClick: 'OnDelete', icon: 'fa-trash', tooltip: 'Elimina', color: 'red' }] },

    ]
  };

}
function News() {
  return {
    type: 'N',
    addButton: true,
    hideif: { hasNotCapacity: ['gestione-news'] },
    restRoute: '/task/news',
    Label: 'News',
    Azioni: [
      { nome: 'Elimina', close: true, class: ' btn ', labelClass: 'ml-1 text-danger font-weight-bold', type: 'POST', restRoute: '/task/news/delete', preAlert: 'Sei sicuro di voler eliminare questo elemento?', capacita: ['gestione-news'], icon: 'fas fa-trash text-danger', hideif: { fieldnotexist: 'id' }, placeholder: 'Elimina', successMex: 'Elemento eliminato con successo', parameter: [{ nome: "id", parameter: 'id' }] },
    ],
    campi: [
      { nome: 'Titolo:', oggetti: ['nome'], modificabile: true, inputType: 'text', class: 'col-lg-12' },
      { nome: 'Body:', oggetti: ['note'], inputType: 'html', modificabile: true, class: 'col-lg-12' },
      { nome: 'Data:', oggetti: ['data_inizio_prevista'], modificabile: true, inputType: 'date', class: 'col-lg-3' },
      { nome: 'Data Fine:', oggetti: ['data_fine_prevista'], modificabile: true, inputType: 'date', class: 'col-lg-3' },
      { nome: 'Pubblica:', oggetti: ['publicata'], modificabile: true, inputType: 'checkbox', class: 'col-lg-3' },
      CampoAggiuntivo.SingleDropdown("Tipologia", "tipologia", [{ id: "L", label: 'Ludoteca' }, { id: "A", label: 'Asilo' }], 'label'),
      {
        type: 'image',
        oggetti: ['id_immagine'],
        imageToServer: 'immagine',
        filename: 'file',
        titleClass: 'control-label col-form-label',
        class: 'col-md-12',
        visibleifProhibited: true,
        modificabile: true
      },

    ]
  };

}



var Environment = () => {
  var env: any = {};
  env = addModule(Attivita(), env);
  env = addModule(AccessoriCliente(), env);
  env = addModule(CrmEnv(), env)
  env = addModule( //notifiche
{
      TaskAddon: {
        checkList: false,
        DynamicFields: [Notifiche()]
      },
      filtrife: [
        { id: "*", label: "Notifiche", capacita: [], module: undefined, tipo: '*' },
      ]
    }
    , env);
  env = addModule( //news
    {
      TaskAddon: {
        checkList: false,
        DynamicFields: [News()]
      },
      filtrife: [
        { id: "N", label: "News", capacita: [], module: undefined, tipo: 'N' },
      ]
    }
    , env);
  env = addModule(Bimbo(), env);
 //20241205-1554-01-/ env = addModule(Prodotti(), env);
  env = addModule({
      ProdottiAddOn: {
        sottoTitolo: false,
        shortDescription: false,
        classeEnergetica: false,
        tags: false,
        video: false,
        dettaglio: false,
        files: false,
        cart: false,
        codice: false,
        codice_produttore: false,
        tipo: false,
      hidePrezzo: true,
      hideImg:true,
        hideDesc: true,
        hideIva: true,
        prezzoSingolo: false,
        standby: false,
        tipi: false, // tipi di prodotto (1 - 2ante klima)
        cat_image: true,
        lista_prezzo: false,
        TranslatedDesc: false,
        codAdhoc: false,
        DragSort: false,
        cat_Sort: false
      },
      ChatAddOn: {
        hideAttachments: true
      }

  }, env);
  env = addModule(Accessori(), env);
  env = addModule(Progetti(), env);
  env = addModule(PresenzeClienti(), env);

  env.TaskAddon.DynamicFields.find(e => e.type == 'P')?.campi?.find(campo => campo.nome == "Accessi")?.header.find(h => h.nome == 'Persona Entrata').parameter.push({nome: "clienti", func: (oggetto, padre)=>{return [padre.cliente]}})
  env.TaskAddon.DynamicFields.find(e => e.type == 'P')?.campi.find(campo => campo.nome == "Accessi")?.header.find(h => h.nome == 'Persona Uscita').parameter.push({nome: "clienti", func: (oggetto, padre)=>{console.log("Presenza: ", padre); return [padre.cliente]}})

  var e = env.TaskAddon.DynamicFields.find(e => e.type == 'P')?.campi.find(campo => campo.nome == "Ospite")

  if(e){
    e.nome = "Bambino"
    env = addModule(e, env)
  }


  env = addModule({
    ProgettiAddon: {
      CampiOfferta: [
        {
          nome: 'Tipo di ordine',
          source: 'TipiProgetti',
          oggetti: ['tipoProgetto'],
          internalOutput: 'tipoProgetto',
          modificabile: true,
          OnChange: 'OnTipoChange',
          inputType: 'singleDropdown',
          placeholder: 'Tipo di ordine',
          disabledif: { fieldexist: 'tipoProgetto' },
          settings: {
            selectIfSingle: true,
            singleSelection: true,
            closeDropDownOnSelection: true,
            singleOutput: true,
            idField: 'id',
            textField: 'nome',
          },
          class: 'col-lg-3',
          visibleifProhibited: true
        },
        CampoAggiuntivo.SingleDropdown("Tipologia", "tipoOfferta", '/settings/get', 'label', {
          parameter: [{ nome: "id", value: "tipo_progetto" }, { nome: "type", value: "tipo_progetto" }],
        }),


      ],
      TipiProgetto: [
        {
          nome: 'Template',
          id: "T",
          VociFields: [],
          colore: "#1baa03"
        },
        {
          nome: 'Menu',
          id: "M",
          VociFields: [],
          colore: "#127ace"
        },
      ],
    },
    Menu: [
      {
        module: "Progetti",
        path: "/kindera/menu-list",
        title: 'Menu',
        icon: "fa fa-cutlery",
        capacita: []
      }
    ]

  }, env);
  env = addModule(Fatture(), env);
  env = addModule(Fornitori(), env);
  env = addModule({//valutazioni
    ClientiAddOn: {
      ptr:true
    },
    ValutazioniValue:[
      { id: 0, label: '0', esito: 'KO' },
      { id: 1, label: '1', esito: 'KO' },
      { id: 2, label: '2', esito: 'KO' },
      { id: 3, label: '3', esito: 'OK' },
      { id: 4, label: '4', esito: 'OK' },
      { id: 5, label: '5', esito: 'OK' },
    ],
    TaskAddon: {
      DynamicFields: [
        {
          type: 'V',
          restRoute: '/task/valutazioni',
          Label: 'Valutazioni',
          addButton: true,
          initObj: [
          ],
          hideif: { hasNotCapacity: [] },
          campi: [
            { nome: 'Valutazioni', oggetti: ['checks'], required: true, modificabile: true, type: 'checkValutazione', class: 'col-lg-12' },
            {
              nome: 'Data',
              oggetti: ['data_inizio_prevista'],
              modificabile: true,
              inputType: 'datetime-local',
              titledivClass: 'input-group-prepend',
              titleClass: 'input-group-text',
              class: "col-lg-12",
            },
            {
              nome: 'Note', oggetti: ['note'], modificabile: true, required: true, inputType: 'textarea',
              titledivClass: 'input-group-prepend',
              titleClass: 'input-group-text',
              class: "col-lg-12",
            },
          ],
          Azioni: [
            {
              nome: 'Elimina',
              close: true,
              class: ' btn ',
              labelClass: 'ml-1 text-danger font-weight-bold',
              type: 'POST',
              restRoute: '/task/valutazioni/delete',
              preAlert: 'Sei sicuro di voler eliminare questo elemento?',
              // capacita: ['gestione-valutazioni'],
              icon: 'fas fa-trash text-danger',
              hideif: { fieldnotexist: 'id', fieldexist: 'firmatario' },
              placeholder: 'Elimina',
              successMex: 'Elemento eliminato con successo',
              parameter: [{ nome: "id", parameter: 'id' }]
            },

          ],
          Headers: [

            { nome: 'Inizio', oggetti: ['data_inizio_prevista'], inputType: 'datetime-local' },
            { nome: 'Fine', oggetti: ['data_fine_prevista'], inputType: 'datetime-local' },

          ]
        }
      ]
    }
  }, env);
  env = addModule({ //persone
    Modules: {
      "Personale": true,
      "PresenzeClienti": true,
      "Dashboard": true,
      "Shared": true,
      "Chat": true
    },

  },env)

  env.theme = 'light';
  env.style = 'FortyFix';
  env.sidebarbg = 'skin6';
  env.logoBg = 'skin6'
  env.HideStatoRegistroPresenze =true;
  env.MainColor = '#3ea26d';
  env.navbarbg = '#FFFFFF';
  env.navbarAccentColor = '#ea582a';
  env.InputLabelColor = '#333333';
  env.InputTextColor = "#4d4d4d";
  env.langSuffix= '_Kindera.json';
  env.BreadcrumbType = "MenuBased";
  env.baseUrl = '/kindera/dashboard/oggi';
  env.homepages = [
    { RuoliAccesso: [2], link: "/kindera/diario" },
  ];
  env.Menu =  [
    {
      title: "Menu",
      class: "has-arrow",
      label: "Menu",
      extralink: true
    },
    {
      module: "dashboard",
      path: 'kindera/dashboard/oggi',
      label: "Dashboard",
      icon: "fa fa-calendar",
      capacita: ["menu-evento"]
    },
    {
      module: "Personale",
      path: "/kindera/",
      title: 'Utenti',
      icon: "far fa-user",
      class: 'has-arrow',
      submenu: [
        {
          path: "/kindera/bambini",
          title: "Bambini",
          capacita: []
        },
        {
          path: "/kindera/accompagnatori",
          title: "Accompagnatori",
          capacita: []
        },
        {
          path: "/kindera/operatori",
          title: "Operatori",
          capacita: []
        }
      ],
      capacita: ["menu-persone"]
    },
    {
      module: "PresenzeClienti",
      path: "/listautenti/presenze",
      title: 'Registro Presenze',
      icon: "fas fa-list",
      capacita: ["menu-news"]
    },
    {
      module: "Progetti",
      path: "/kindera/",
      title: 'Menu',
      icon: "mdi mdi-calendar-multiple-check"/*"mdi mdi-calendar-multiple-check"*/,
      class: 'has-arrow',
      submenu: [
        {
          path: "/kindera/dashboard/menu",
          title: "Dashboard",
          capacita: ["menu-progetti"]
        },
        {
          path: "/kindera/menu-list",
          title: "Lista Menu",
          capacita: ["gestione-progetti"]
        },
        {
          module: "Prodotti",
          path: "progetti/prodotti/68/lista",
          title: 'menu.ProdottiLabel',
          icon: "mdi mdi-barcode-scan",
          capacita: ["menu-prodotti"]
        },
      ],
      capacita: ['menu-progetti', 'menu-prodotti',"gestione-progetti"]
    },

    {
      path: "/kindera/attivita-list",
      title: "Attività",
      icon: "fas fa-puzzle-piece",
      capacita: ["menu-scadenzario"]
    },
    {
      module: "PresenzeClienti",
      path: "/kindera/",
      title: 'Diario Giornalierio',
      icon: "fa fa-address-book",
      class: 'has-arrow',
      capacita: ["menu-magazzini", "menu-val"],
      submenu: [
        {
          path: "/kindera/diario",
          title: "Diario Del Giorno",
          capacita: ['gestione-val']
        },
        {
          path: "/kindera/armadietto",
          title: "Armadietto",
          capacita: ['gestione-movimentazioni']
        }
      ],
    },
    {
      module: "Task",
      path: "/kindera/bacheca-list",
      title: 'Bacheca',
      icon: "fa fa-book",
      capacita: ["menu-evento"]
    },
    {
      module: "Task",
      path: "/kindera/rette",
      title: 'Rette',
      icon: "fas fa-dollar-sign",
      capacita: ["menu-news"]
    },
    {
      module: "Task",
      path: "/kindera/news-list",
      title: 'News',
      icon: "fas fa-newspaper",
      capacita: ["menu-news"]
    },
    {
      module: "Task",
      path: "/kindera/notifiche",
      title: 'Notifiche',
      icon: "fa fa-bell",
      capacita: ["menu-notifiche"]
    },
    {
      module: "Task",
      path: "/kindera/salvadanaio",
      title: 'Salvadanaio',
      icon: "fas fa-piggy-bank",
      capacita: ["menu-evento"]
    },
    {
      module: "Chat",
      path: "/chat/messages/entry",
      title: 'Chat',
      icon: "fas fa-comment-alt",
      capacita: ['menu-chat']
    },
    {
      module: "Settings",
      path: "/dashboard/categorie/S",
      title: "Setting Categorie Attivita",
      icon: "fas fa-cogs",
      capacita: ["menu-settings"]
    },


  ]

  return env;
};

var FullEnv = () => {
  var env: any = {};
  env = getModule(Environment());
  env['ProgettiAddon'].CampiOfferta?.forEach(campo => {

    switch (campo.nome) {
      case 'Offerta.Responsabile':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
      case 'cliente.commerciale':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
      case 'cliente.segnalatore':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
      case 'Colore':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
      case 'Oggetto:':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
      case 'Numero Ordine:':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
      case 'Lavorato':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
      case 'Offerta.Conferma':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
      case 'Offerta.Offerta':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
      // case 'Offerta.Accettazione':
      //   campo.hideif = { hasCapacity: ['is-cliente-ordine'] };
      //   break;
      case 'Completato:':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
      case 'Annullato:':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
      case 'Data Annullamento:':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
      case 'Note Private':
        campo.hideif = { fieldexist: 'id', fieldnotexist: 'id' };
        break;
    }
  })
  return env;
};


export var environment: any = FullEnv();


